export const dictionary = {
    schema: {
        ["signal-plot-config"]: {
            properties: {
                use: "Use",
                showThreshold: "Threshold",
                showProjection: "Projection",
                showHistogram: "Histogram",
            },
        },
    },
};
